import React from 'react';

/**
 * Illuminati SVG converted to a React component
 * @param {Object} props - Component props
 * @param {string} props.color - Color to apply to the SVG (default: 'currentColor')
 * @param {string} props.width - Width of the SVG (default: '100px')
 * @param {string} props.height - Height of the SVG (default: '100px')
 * @param {Object} props.style - Additional style properties
 * @param {string} props.className - CSS class name
 */
const IlluminatiIcon = ({ 
  color = 'currentColor', 
  width = '100px', 
  height = '100px',
  style = {},
  className = '',
  ...rest
}) => {
  return (
    <svg 
      width={width} 
      height={height}
      viewBox="0 0 1200 1200"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...style }}
      className={className}
      {...rest}
    >
      <path 
        fill={color}
        d="m1159.4 1127.3-538.42-1076.8c-8.6211-17.234-33.297-17.258-41.926 0l-539.06 1078.1c-7.7773 15.555 3.5469 33.918 20.961 33.918h1078.1c0.019531 0.003907 0.03125 0.003907 0.050781 0 12.941 0 23.438-10.496 23.438-23.438 0.003906-4.293-1.1523-8.3125-3.1641-11.77zm-1060.5-11.668 501.14-1002.3 501.14 1002.3z"
      />
      <path 
        fill={color}
        d="m319.71 827.68c-1.3008 4.3633-1.3008 9.0117 0 13.375 34.926 117.32 143.64 203.81 273.44 203.81 129.45 0 238.41-86.16 273.44-203.81 1.3008-4.3633 1.3008-9.0117 0-13.375-34.922-117.3-143.63-203.81-273.44-203.81-129.46 0-238.42 86.168-273.44 203.81zm499.86 6.6875c-31.969 96.688-124.07 163.62-226.41 163.62-102.35 0-194.45-66.941-226.42-163.62 31.969-96.688 124.07-163.62 226.42-163.62s194.45 66.938 226.41 163.62z"
      />
      <path 
        fill={color}
        d="m482.8 834.36c0 64.617 52.57 117.19 117.19 117.19 64.617 0 117.19-52.57 117.19-117.19 0-64.617-52.57-117.19-117.19-117.19-64.617 0-117.19 52.57-117.19 117.19zm117.19-70.312c38.77 0 70.312 31.543 70.312 70.312s-31.539 70.312-70.312 70.312c-38.77 0-70.312-31.543-70.312-70.312s31.543-70.312 70.312-70.312z"
      />
    </svg>
  );
};

export default IlluminatiIcon;
